export class Word {
  wordId: string;
  word: string;
  mean: string;

  means(): string[] {
    return this.mean.split(',');
  }
}
